var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "chart",
      staticClass: "chart",
      style: { height: _vm.height, ..._vm.chartStyle },
    },
    [_vm._v("饼图")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }